import { School } from '../school';
import { Invoice } from '../invoice';

export class InvoiceItem {
    constructor(
        public id?: number,
        public subTotal?: number,
        public taxRate?: number,
        public taxAmount?: number,
        public total?: number,
        public school?: School,
        public invoice?: Invoice,
        public createdDate?: Date,
        public description?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice-item/invoice-item.model.ts